// WhatsApp Service for sending order confirmations and payment instructions
// Using WhatsApp Web API integration

// Store WhatsApp number - change this to your WhatsApp number
const STORE_WHATSAPP_NUMBER = "201551932386";

// InstaPay transfer link
const INSTAPAY_TRANSFER_LINK = "https://ipn.eg/S/ghtwry2/instapay/1QrxX8";

/**
 * Build WhatsApp message for COD (Cash On Delivery)
 * @param {Object} order - The order object
 * @returns {String} - Formatted message text in English
 */
export const buildCODMessage = (order) => {
const items = order.items?.map(item => 
  `• ${item.name} (${item.category === 'Frames' ? 'Frame' : 'Sticker'}) ${item.size !== null ? `(${item.size})` : '' } × ${item.count ?? 1} = ${(
    (item.type !== "custom" && item.category === 'Frames' ? item.size === '20x30' ? item.smallframeprice : item.bigframeprice : item.price) * (item.count ?? 1)
  ).toFixed(0)} جنيه`
).join('\n') || "• لا توجد منتجات";

let message = `تأكيد الطلب - متجر GedarStore\n\n`;
message += `شكرًا لطلبك!\n\n`;

message += `*تفاصيل الطلب:*\n`;
message += `رقم الطلب: #${order.orderId}\n`;
message += `الاسم: ${order.customer?.fullName || "غير متوفر"}\n`;
message += `الهاتف: ${order.customer?.phone || "غير متوفر"}\n`;
message += `المدينة: ${order.customer?.city || "غير متوفر"}\n`;
message += `العنوان: ${order.customer?.address || "غير متوفر"}\n\n`;

message += `*المنتجات:*\n${items}\n\n`;

message += `*ملخص الطلب:*\n`;
message += `المجموع الفرعي: ${order.subtotal} جنيه\n`;
message += `الشحن: ${order.shipping} جنيه\n`;
{order.couponDiscount !== 0  ? 
  message += `الخصم : ${order.couponDiscount} ج.م\n`
    :
      message += `الخصم : ${order.couponDiscount} ج.م\n`
  }
message += `*الإجمالي: ${order.total} جنيه*\n\n`;

// إضافة الملاحظات إذا وُجدت
if (order.notes && order.notes.trim()) {
  message += `*ملاحظات العميل:*\n${order.notes}\n\n`;
}

message += `*طريقة الدفع: الدفع عند الاستلام*\n`;
message += `سيتم توصيل طلبك قريبًا.\n`;
message += `يرجى التأكد من توفر المبلغ المطلوب بالضبط.\n`;
message += `مدة التوصيل: 2-3 أيام عمل\n\n`;

message += `شكرًا لتسوقك معنا!\n`;
message += `فريق GedarStore`;

return message;
};

/**
 * Build WhatsApp message for InstaPay
 * @param {Object} order - The order object
 * @returns {String} - Formatted message text in English
 */
export const buildInstaPayMessageNew = (order) => {
 const items = order.items?.map(item => 
    `• ${item.name} (${item.category === 'Frames' ? 'Frame' : 'Sticker'}) ${item.size !== null ? `(${item.size})` : ''} × ${item.count ?? 1} = ${(item.type !== "custom" && item.category === 'Frames' ? item.size === '20x30' ? item.smallframeprice : item.bigframeprice : item.price) * (item.count ?? 1)} ج.م`
  ).join('\n') || "• لا توجد منتجات";

  let message = `تأكيد الطلب - GedarStore \n\n`;
  message += `شكرًا لطلبك!\n\n`;
  
  message += `*تفاصيل الطلب:*\n`;
  message += `رقم الطلب: #${order.orderId}\n`;
  message += `الاسم: ${order.customer?.fullName || "غير متوفر"}\n`;
  message += `الهاتف: ${order.customer?.phone || "غير متوفر"}\n`;
  message += `المدينة: ${order.customer?.city || "غير متوفر"}\n`;
  message += `العنوان: ${order.customer?.address || "غير متوفر"}\n\n`;

  message += `*المنتجات:*\n${items}\n\n`;

  message += `*ملخص الطلب:*\n`;
  message += `المجموع الفرعي: ${order.subtotal} ج.م\n`;
  message += `الشحن: ${order.shipping} ج.م\n`;
  {order.couponDiscount !== 0  ? 
  message += `الخصم : ${order.couponDiscount} ج.م\n`
    :
      message += `الخصم : ${order.couponDiscount} ج.م\n`
  }
  message += `*الإجمالي: ${order.total} ج.م*\n\n`;

  // الملاحظات
  if (order.notes && order.notes.trim()) {
    message += `*ملاحظات العميل:*\n${order.notes}\n\n`;
  }

  message += `*طريقة الدفع: إنستاباي*\n`;
  message += `يرجى إتمام الدفع باستخدام الرابط أدناه:\n\n`;
  message += `${INSTAPAY_TRANSFER_LINK}\n\n`;

  message += `*تعليمات الدفع:*\n`;
  message += `1. اضغط على الرابط أعلاه أو انسخه في المتصفح\n`;
  message += `2. أدخل المبلغ: ${order.total} ج.م\n`;
  message += `3. أكمل عملية الدفع\n`;
  message += `4. أرسل لنا صورة تأكيد الدفع\n`;
  message += `5. سنقوم بمعالجة وشحن طلبك فورًا\n\n`;

  message += `شكرًا لتسوقك معنا!\n`;
  message += `فريق متجر جِدار`;

  return message;};

/**
 * Build WhatsApp message for order confirmation (main function)
 * @param {Object} order - The order object
 * @param {String} paymentMethod - Payment method (cod, instapay, wallet, etc.)
 * @returns {String} - Formatted message text in English
 */
export const buildOrderConfirmationMessage = (order, paymentMethod = "cod") => {
  if (paymentMethod === "instapay") {
    return buildInstaPayMessageNew(order);
  } else {
    return buildCODMessage(order);
  }
};

/**
 * Generate WhatsApp URL for sending message
 * @param {String} message - The message to send
 * @param {String} phoneNumber - Optional phone number (default: store number)
 * @returns {String} - WhatsApp URL
 */
export const generateWhatsAppURL = (message, phoneNumber = STORE_WHATSAPP_NUMBER) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
};

/**
 * Open WhatsApp with message
 * @param {String} message - The message to send
 * @param {String} phoneNumber - Optional phone number
 */
export const openWhatsAppMessage = (message, phoneNumber = STORE_WHATSAPP_NUMBER) => {
  const url = generateWhatsAppURL(message, phoneNumber);
  window.open(url, "_blank");
};

/**
 * Build InstaPay payment message with reference code (legacy)
 * @param {Object} order - The order object
 * @param {String} instaPayTag - InstaPay tag to send payment to
 * @returns {String} - Formatted message
 */
export const buildInstaPayMessage = (order, instaPayTag) => {
  return buildInstaPayMessageNew(order);
};

/**
 * Send WhatsApp message via customer's phone (using message builder)
 * This opens WhatsApp Web for the user to send the message manually
 * @param {String} phoneNumber - Customer's phone number
 * @param {String} message - Message to send
 */
export const sendWhatsAppToCustomer = (phoneNumber, message) => {
  // Clean phone number (remove spaces, dashes, etc.)
  const cleanNumber = phoneNumber.replace(/\D/g, '');
  const formattedNumber = cleanNumber.startsWith('20') ? cleanNumber : '20' + cleanNumber;
  
  const url = generateWhatsAppURL(message, formattedNumber);
  window.open(url, "_blank");
};

/**
 * Copy message to clipboard for manual sending
 * @param {String} message - Message to copy
 */
export const copyMessageToClipboard = (message) => {
  navigator.clipboard.writeText(message).then(() => {
    return true;
  }).catch(err => {
    console.error("Failed to copy message:", err);
    return false;
  });
};

const whatsappService = {
  buildOrderConfirmationMessage,
  buildCODMessage,
  buildInstaPayMessageNew,
  generateWhatsAppURL,
  openWhatsAppMessage,
  buildInstaPayMessage,
  sendWhatsAppToCustomer,
  copyMessageToClipboard,
  STORE_WHATSAPP_NUMBER,
  INSTAPAY_TRANSFER_LINK
};

export default whatsappService;
